module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_8003.10bc113a.png";